export default __webpack_public_path__ + "static/TIMBERLINE-M-SERIES-26-D-front-WEB-a6a9d7e8c67558a346db521576d3d29e.png";